import { useT } from "@/app/translations/useT";
import { ConceptFlowTagPairView } from "@/app/types/home/ConceptFlow";
import styles from "../ConceptFlow.module.css";

type Props = {
  pair: ConceptFlowTagPairView;
  className?: string;
};

export default function ConceptFlowTagPair(props: Props) {
  const { pair, className } = props;
  const T = useT();

  return (
    <span className={`${styles.tagPair} ${className ?? ""}`} style={pair.style}>
      {pair.deck.map((chip) => (
        <span
          className={`${styles.tag} ${styles[chip.toneClass]}`}
          style={chip.style}
          key={chip.labelKey}
        >
          {T(chip.labelKey)}
        </span>
      ))}
    </span>
  );
}
